import { z } from 'zod';
import { AmountCentsSchema, CurrencyCodeSchema, IbanSchema, IsoTimestampSchema, SignedAmountCentsSchema, UuidSchema, } from './primitives.js';
import { TransactionStatusSchema, TransactionTypeSchema } from './enums.js';
/**
 * Transaction record. Mirrors the `transactions` table.
 *
 * USP #3 (Real Rate Display) requires us to store BOTH our applied rate AND
 * the mid-market rate at the time of the transaction. The user can then see
 * the real spread on every FX operation.
 */
export const TransactionSchema = z.object({
    id: UuidSchema,
    account_id: UuidSchema,
    swan_transaction_id: z.string().min(1),
    type: TransactionTypeSchema,
    status: TransactionStatusSchema,
    /** Signed: positive = credit to our user, negative = debit. */
    amount_cents: SignedAmountCentsSchema,
    currency: CurrencyCodeSchema,
    // FX context — populated only for fx_conversion or cross-currency operations.
    fx_source_currency: CurrencyCodeSchema.nullable(),
    fx_source_amount_cents: AmountCentsSchema.nullable(),
    fx_rate: z.number().positive().nullable(),
    /** Mid-market reference rate at the time we executed — USP #3. */
    fx_mid_market_rate: z.number().positive().nullable(),
    counterparty_name: z.string().nullable(),
    counterparty_iban: IbanSchema.nullable(),
    reference: z.string().max(140).nullable(),
    booked_at: IsoTimestampSchema.nullable(),
    created_at: IsoTimestampSchema,
});
//# sourceMappingURL=transaction.js.map